import React, { useState } from 'react'
import DataTable from '../../../components/datatable'
import { PAGINATION_DEFAULT } from '../../../utils/constants'
import { useHistory } from 'react-router-dom'
import {
  useDeleteAnnouncement,
  useGetAnnouncements,
} from '../../../redux/employees/hook/announcement'

const PastAnnouncements = () => {
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })

  const history = useHistory()

  const { mutateAsync: deleteAnnouncement } = useDeleteAnnouncement()

  const { data: announcements } = useGetAnnouncements(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const tableConfig = {
    headers: ['Announcement Title', 'Audience', 'Scheduled Published Date'],
    keys: ['title', 'recipient_type', 'publish_date'],
    mobileHeader: {
      left: {
        title: 'Announcement Title',
        key: 'title',
      },
      right: {
        title: 'Audience',
        key: 'audience',
      },
    },
  }

  const actionConfig = [
    {
      name: 'View',
      color: 'green',
      action: (id) => {
        let index = announcements.data.findIndex((item) => item.id === id)
        history.push('/announcements/view/' + announcements.data[index].id)
      },
    },
    {
      name: 'Delete',
      color: 'red',
      action: async (id) => {
        let index = announcements.data.findIndex((item) => item.id === id)
        await deleteAnnouncement(announcements.data[index].id)
      },
    },
  ]
  return (
    <div>
      <DataTable
        data={announcements}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        tableType={'announcements'}
        searchData={true}
      />
    </div>
  )
}

export default PastAnnouncements
